<template>
  <v-container
    lcd
    fluid
    grid-list-xl
    pt-0
  >
    <v-layout wrap>
      <!-- <v-flex
        xs12
        sm6
        lg3>
        <material-stats-card
          :value="summaryCaseName"
          style="margin-bottom:-20px !important;"
          class="v-offset-none"
          color="purple"
          icon="mdi-folder-open"
          title="案名"/>
      </v-flex>
      <v-flex
        xs12
        sm6
        lg3>
        <material-stats-card
          :value="summaryDate"
          style="margin-bottom:-20px !important;"
          color="indigo"
          icon="mdi-calendar"
          title="資料日期"/>
      </v-flex>
      <v-flex
        xs12
        sm6
        lg3>
        <material-stats-card
          :value="summaryEMS"
          style="margin-bottom:-20px !important;"
          color="light-blue"
          icon="mdi-factory"
          title="EMS"/>
      </v-flex>
      <v-flex
        xs12
        sm6
        lg3>
        <material-stats-card
          :value="(responseAreaData.failRate * 100).toFixed(1) + '%'"
          :class="responseAreaData.warningColor || 'green'"
          :color="responseAreaData.color"
          :icon="responseAreaData.icon || 'mdi-check'"
          class="title-color"
          style="margin-bottom:-20px !important;"
          title="Fail Rate"/>
      </v-flex> -->
      <v-flex
        class="v-flex__first"
        style="margin-top: 55px !important;"
        xs12>
        <material-card
          class="v-flex v-c3-chart"
        >
          <div
            class="chart-btn c3-chart c3-click"
            style="margin-top: -3.5rem!important;width:100%;">
            <material-notification
              color="brown"
              class="mb-3 h4 font-weight-bold"
            >
              Brightness 直方圖 [Mode：{{ Mode }}]
              <div class="float-right">
                <!-- <v-btn
                  v-for="(mode,m) in calibrationModeMenu"
                  :key="'m'+m"
                  class="black text-light mr-0 ml-2 px-2"
                  @click="calibrationMode=mode">{{ mode }}</v-btn> -->
              </div>
              <p class="m-0">Factory：{{ propData.factoryName }} ｜ Project：{{ propData.projectName }} ｜ prodId：{{ propData.prodId }} ｜ Time Interval：{{ propData.startTime }} ~ {{ propData.endTime }}</p>
              <!-- <h6 class="my-1 float-right">篩選條件最後更新時間：{{ lcdFilterUpdateTime }}</h6> -->
            </material-notification>
            <vue-c3 :handler="handler_bar"/>
          </div>
          <!-- <div>
            <v-flex
              xs12
              style="margin-left: 16px!important;padding: 0!important;">
              <v-autocomplete
                v-model="xRange"
                :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                :items="[
                  { text: 0.01, value: 0.01 },
                  { text: 0.025, value: 0.025 },
                  { text: 0.05, value: 0.05 }
                ]"
                label="數值區間"
                class="v-text-field__slot v-text-field__details-none"
                persistent-hint
                outlined
              />
            </v-flex>
            <material-notification
              :class="{'text-white' : theme==='dark' , 'text-body' : theme==='light'}"
              :color="theme==='dark'?'black':'white'"
              class="mt-1 py-1 mb-1 h4 font-weight-bold"
            >
              <v-card-title
                primary-title
                class="mt-0 px-0 py-0 d-block text-center">
                <div class="headline m-auto">
                  <h6 class="my-0 text-left">Max</h6>
                  <h2 class="my-0 text-right">{{ Max.value.toFixed(2) }}</h2>
                  <hr class="my-3 white">
                  <h6 class="my-0 text-left">Avg</h6>
                  <h2 class="my-0 text-right">{{ Avg.value.toFixed(2) }}</h2>
                  <hr class="my-3 white">
                  <h6 class="my-0 text-left">Min</h6>
                  <h2 class="my-0 text-right">{{ Min.value.toFixed(2) }}</h2>
                </div>
              </v-card-title>
            </material-notification>
          </div> -->
        </material-card>
        <div v-if="showtable === true">
              <material-notification
              color="brown"
              class="mb-3 h4 font-weight-bold"
            >
              <p class="m-0">{{clicktitle}}</p>
              <!-- <h6 class="my-1 float-right">篩選條件最後更新時間：{{ lcdFilterUpdateTime }}</h6> -->
            </material-notification>
 <material-card
          :style="'max-width: calc(100vw - '+(Number(shrink)+32)+'px);'"
          class="d-table-t0 no-data-left">

        <v-data-table
          :headers="[
            { text: 'BiosSN', value: 'isn' ,class: 'table-width-150',sortable: true},
            { text: '值', value: 'value',class: 'table-width-185',sortable: true }
          ]"
          :items="responseData"
          :pagination.sync="pagination.current"
          :rows-per-page-items="rowsAmount"
          :class="{ 'showList': true}"
          class="freeze-title height-row-3"
                      multi-sort
            hide-actions
        >
         <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text-general text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <tr>
                <td class="table-width-150">{{ item.isn }}</td>
                <td class="table-width-185">{{ item.value }}</td>
                <td class="table-width-300">
                  <v-btn
                    class="mx-0 mr-3 font-weight-bold small"
                    color="orange"
                    @click="downloadHitTraceLog(item.pk)">
                    <v-icon class="mr-2">mdi-download</v-icon>HITTrace LOG
                  </v-btn>
                  <v-btn
                    class="mx-0 font-weight-bold small"
                    color="orange"
                    @click="downloadNBreport(item.pk)">
                    <v-icon class="mr-2">mdi-download</v-icon>NB Report
                  </v-btn>
                </td>
              </tr>
            </template>
        </v-data-table>
        <div
            v-if="pagination.current.rowsPerPage != -1"
            class="text-xs-center pt-2 d-inline-block"
            style="margin-left: 0px;width: calc(100% - 140px);">
            <v-pagination
              v-model="pagination.page"
              :length="pages"/>
          </div>
          <v-autocomplete
            v-if="pagination.current.rowsPerPage != -1"
            v-model="pagination.page"
            :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
            :items="pageslist"
            class="v-text-field__slot d-inline-block float-right mr-0"
            style="width: 90px;"
            persistent-hint
            outlined
          />
      </material-card>
      </div>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="loadingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        LOADING 載入中
      </p>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :top="true"
      :color="snackbarColor">
      {{ snackbarMsg }}
      <v-btn
        dark
        flat
        @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import Vue from 'vue'
import VueC3 from 'vue-c3'
import 'c3/c3.min.css'
import { mapState } from 'vuex'
import Loading from '@/assets/img/loading.gif'

export default {
  name: 'ShowLcdCalibrationGammaDiffBarChart',
  components: {
    VueC3
  },
  data () {
    return {
      snackbar: false,
      snackbarColor: 'red',
      snackbarMsg: '',
      Loading,
      loadingView: false,
      propData: {},
      // lcdFilterUpdateTime: '',
      Min: {
        value: 0
      },
      Max: {
        value: 0
      },
      Avg: {
        value: 0
      },
      RangeMin: 0,
      RangeMax: 9999,
      RangeMinLimit: 0.01,
      RangeMaxLimit: 0.05,
      xRange: 0.025,
      LessRangeCount: {
        value: 0
      },
      OverRangeCount: {
        value: 0
      },
      Mode: 'Brightness ',
      selectedDataType: 'result',
      // RangeCount: 1,
      responseAreaData: [],
      barXaxisItem: ['value'],
      barXaxisItemName: ['Gamma Diff'],
      barXaxisName: [],
      barXaxisValue: [],
      handler_bar: new Vue(),
      selectedBar: null, // 存儲選中的索引
      showTable: false, // 控制表格顯示
      responseData: [], // 存儲表格數據
      newData: [],
      pagination: {
        page: 1,
        current: {
          descending: null,
          page: 1,
          rowsPerPage: 50,
          sortBy: null,
          totalItems: 0
        }
      },
      pages: 4,
      xAxis: Array.from({ length: 11 }, (_, i) => (0.9 + i * 0.01).toFixed(2)),
      ResultHistogram: {},
      SRGBHistogram: {},
      P3Histogram: {},
      rowsAmount: [10, 25, 50, 100],
      showtable: false,
      chartData: [],
      clicktitle: ''

    }
  },
  computed: {
    ...mapState('app', ['theme', 'shrink']),
    pageslist () {
      let i = 0
      const list = []
      if (this.pagination.current.rowsPerPage) {
        for (i = 0; i < Math.ceil(this.pagination.current.totalItems / this.pagination.current.rowsPerPage); i++) {
          list.push(i + 1)
        }
      }
      return list
    },
    options_bar () {
      this.chartData = this.getBarChartData()
      console.info(666)
      console.info(this.chartData)
      return {
        data: {
          columns: this.chartData.columns,
          labels: true,
          type: 'bar', // 设置为直方图
          colors: {
            0: '#4571C4',
            10: '#ED7D30',
            20: '#A5A5A5',
            30: '#FDC002',
            50: '#5C9BD5',
            75: '#6FAD45',
            100: '#274478'
          },
          onclick: (d, element) => {
            console.info('所有', d) // 记录点击的 X 轴索引
            console.info('点击的索引：', d.index) // 记录点击的 X 轴索引
            console.info('点击的数据列：', d.name) // 记录点击的 Y 轴数据列名
            console.info('点击的数据值：', d.value) // 记录点击的数值
            console.info('DOM 元素：', element) // 获取点击的 DOM 元素

            this.selectedBar = d.index // 记录点击的索引
            this.selectedSeries = d.name // 记录点击的系列名称
            this.showTable = true // 显示表格
            this.loadTableData(d.index, d.name) // 根据索引和系列名加载表格数据
          }
        },
        axis: {
          x: {
            label: {
              text: 'Y_Diff',
              position: 'outer-center'
            },
            type: 'category', // 使用分类类型
            categories: this.chartData.categories,
            tick: {
              rotate: -45,
              multiline: false
            }
          },
          y: {
            label: {
              text: '数量(log)',
              position: 'outer-middle'
            }
          }
        },
        tooltip: {
          format: {
            title: (d) => {
              return `${this.chartData.categories[d]}区间`
            },
            value: (value) => {
              return `${value}`
            }
          }
        },
        grid: {
          x: {
            show: true
          },
          y: {
            show: true
          }
        },
        legend: {
          position: 'bottom',
          padding: 16,
          show: true
        },
        padding: {
          bottom: 40 // 根據你的需要調整 40~60
        },
        size: {
          height: 600
        }
      }
    }
  },
  watch: {
    xRange (val) {
      this.doSummary()
    },
    selectedDataType (newVal) {
      this.selectchart(newVal)
    },
    pagination: {
      handler (newName, oldName) {
        if (this.IsSubmitPage) {
          return
        }
        const start = (this.pagination.page - 1) * this.pagination.current.rowsPerPage
        const end = start + this.pagination.current.rowsPerPage
        console.info(this.newData.slice(start, end))
        this.responseData = this.newData.slice(start, end)
      },
      immediate: true,
      deep: true
    }
  },
  mounted () {
    this.$store.dispatch('getAuthorize', '/lcd/lcdCalibrationAnalyzer/showLcdCalibrationBrightnessChart')
      .then(response => {
        if (response.status === 'success' && response.data.accessible) {
          const cache = sessionStorage.getItem('cacheFilterInfo')
          if (cache) {
            // ✅ 優先用 sessionStorage 中的副本
            this.propData = JSON.parse(cache)
          } else {
            // ✅ 第一次從 localStorage 拿到後，存入 sessionStorage
            const raw = localStorage.getItem('lcdFilterInfo')
            if (raw) {
              this.propData = JSON.parse(raw)
              sessionStorage.setItem('cacheFilterInfo', raw)
            }
          }
          // this.lcdFilterUpdateTime = localStorage.getItem('lcdFilterUpdateTime')
          this.doSubmit('result')
        } else if (response.errCode === 'E10000002') {
          const routeData = this.$router.resolve({ path: '/noEnter/E10000002' })
          localStorage.setItem('errormsg', response.errMsg)
          window.location.assign(routeData.href)
        } else {
          const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
          window.location.assign(routeData.href)
        }
      })
      .catch(err => {
        console.log(err)
        const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
        window.location.assign(routeData.href)
      })
  },
  methods: {
    doSummary (type) {
      this.ResultHistogram = {
        'resultNativeCoverageSRgb': new Array(this.xAxis.length).fill(0),
        'resultNativeCoverageP3': new Array(this.xAxis.length).fill(0),
        'resultCoverageSRgb': new Array(this.xAxis.length).fill(0),
        'resultCoverageP3': new Array(this.xAxis.length).fill(0)
      }
      this.SRGBHistogram = {
        'srgbNativeCoverageSRgb': new Array(this.xAxis.length).fill(0),
        'srgbCoverageSRgb': new Array(this.xAxis.length).fill(0)
      }
      this.P3Histogram = {
        'p3NativeCoverageP3': new Array(this.xAxis.length).fill(0),
        'p3CoverageP3': new Array(this.xAxis.length).fill(0)
      }
      this.responseAreaData.forEach(item => {
        // 遍历第一组数据
        Object.keys(this.ResultHistogram).forEach(key => {
          const value = item[key]
          if (typeof value === 'number') {
            let index
            if (value < 0.9) {
              index = 0 // 0.00 - 0.90 归到索引 0
            } else if (value <= 1.0) {
              index = Math.min(10, Math.floor((value - 0.9) / 0.01) + 1) // 0.90 - 1.00 归到索引 1-10
            }
            if (index !== undefined) {
              this.ResultHistogram[key][index]++
            }
          }
        })

        // 遍历第二组数据
        Object.keys(this.SRGBHistogram).forEach(key => {
          const value = item[key]
          if (typeof value === 'number') {
            let index
            if (value < 0.9) {
              index = 0
            } else if (value <= 1.0) {
              index = Math.min(10, Math.floor((value - 0.9) / 0.01) + 1)
            }
            if (index !== undefined) {
              this.SRGBHistogram[key][index]++
            }
          }
        })

        // 遍历第三组数据
        Object.keys(this.P3Histogram).forEach(key => {
          const value = item[key]
          if (typeof value === 'number') {
            let index
            if (value < 0.9) {
              index = 0
            } else if (value <= 1.0) {
              index = Math.min(10, Math.floor((value - 0.9) / 0.01) + 1)
            }
            if (index !== undefined) {
              this.P3Histogram[key][index]++
            }
          }
        })
      })
      if (type === 'result') {
        this.handler_bar.$emit('init', this.options_bar)
      } else if (type === 'srgb') {
        this.handler_bar.$emit('init', this.options_bar_SRGB)
      } else {
        this.handler_bar.$emit('init', this.options_bar_P3)
      }
    },
    doSubmit (type) {
      this.loadingView = true
      this.$http.post('/api/lcd/analyzeMgmt/brightnessBarChartDataList', this.propData).then(res => res.data)
        .then(res => {
          this.loadingView = false
          if (res.status === 'success') {
            this.responseAreaData = res.data
            console.info(this.responseAreaData)
            this.handler_bar.$emit('init', this.options_bar)
          }
        })
    },
    getBarChartData () {
      // 固定 x 軸分段
      const buckets = [
        { label: '0%', min: 0, max: 0.02 },
        { label: '2%', min: 0.02, max: 0.04 },
        { label: '4%', min: 0.04, max: 0.06 },
        { label: '6%', min: 0.06, max: 0.08 },
        { label: '8%', min: 0.08, max: 0.1 },
        { label: 'others', min: 0.1, max: Infinity }
      ]

      // 統計資料：{ [nits]: { [bucketLabel]: count } }
      const countMap = {}

      this.responseAreaData.forEach(device => {
        device.brightnessList.forEach(({ nits, ydiff }) => {
          if (!countMap[nits]) countMap[nits] = {}
          const bucket = buckets.find(b => ydiff >= b.min && ydiff < b.max)
          const label = bucket.label
          countMap[nits][label] = (countMap[nits][label] || 0) + 1
        })
      })

      // 將 countMap 轉換成 C3 格式
      const columns = []

      Object.keys(countMap).sort((a, b) => a - b).forEach(nits => {
        const row = [nits.toString()]
        buckets.forEach(bucket => {
          row.push(countMap[nits][bucket.label] || 0)
        })
        columns.push(row)
      })

      // 回傳 chart 用的資料結構
      return {
        columns,
        categories: buckets.map(b => b.label)
      }
    },
    downloadNBreport (pk) {
      this.processingView = true
      this.$http.get(`/api/lcd/analyzeMgmt/downloadNBReport/${pk}`, {}, { responseType: 'blob' })
        .then(res => {
          console.info(res)
          this.processingView = false
          if (res.data.type === 'application/json') {
            return new Promise((resolve, reject) => {
              const reader = new FileReader()
              reader.onload = () => {
                res.data = JSON.parse(reader.result)
                if (res.data.status === 'success') {
                  alert(res.data.data)
                } else {
                  this.snackbar = true
                  this.snackbarColor = 'red'
                  this.snackbarMsg = res.data.errMsg + ' (' + res.data.errCode + ')'
                }
              }
              reader.onerror = () => {
                reject(res.data.errMsg || res.data.data)
              }
              reader.readAsText(res.data)
            })
          } else if (res.data.status !== 'failure' && res.headers['content-disposition']) {
            const blob = new Blob([res.data], { type: 'application/octet-stream' })
            const url = window.URL.createObjectURL(blob)
            const fileName = res.headers['content-disposition'].split(';')[1].split('=')[1]
            const downloadLink = document.createElement('a')
            downloadLink.href = url
            downloadLink.download = fileName

            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
          } else {
            this.snackbar = true
            this.snackbarColor = 'red'
            this.snackbarMsg = '下載失敗，請通知系統管理員'
          }
        })
        .catch(err => {
          this.processingView = false
          this.snackbar = true
          this.snackbarColor = 'orange'
          this.snackbarMsg = err
        })
    },
    downloadHitTraceLog (pk) {
      this.processingView = true
      this.$http.get(`/api/lcd/analyzeMgmt/downloadHitTraceLog/${pk}`, {}, { responseType: 'blob' })
        .then(res => {
          console.info(res)
          this.processingView = false
          if (res.data.type === 'application/json') {
            return new Promise((resolve, reject) => {
              const reader = new FileReader()
              reader.onload = () => {
                res.data = JSON.parse(reader.result)
                if (res.data.status === 'success') {
                  alert(res.data.data)
                } else {
                  this.snackbar = true
                  this.snackbarColor = 'red'
                  this.snackbarMsg = res.data.errMsg + ' (' + res.data.errCode + ')'
                }
              }
              reader.onerror = () => {
                reject(res.data.errMsg || res.data.data)
              }
              reader.readAsText(res.data)
            })
          } else if (res.data.status !== 'failure' && res.headers['content-disposition']) {
            const blob = new Blob([res.data], { type: 'application/octet-stream' })
            const url = window.URL.createObjectURL(blob)
            const fileName = res.headers['content-disposition'].split(';')[1].split('=')[1]
            const downloadLink = document.createElement('a')
            downloadLink.href = url
            downloadLink.download = fileName

            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
          } else {
            this.snackbar = true
            this.snackbarColor = 'red'
            this.snackbarMsg = '下載失敗，請通知系統管理員'
          }
        })
        .catch(err => {
          this.processingView = false
          this.snackbar = true
          this.snackbarColor = 'orange'
          this.snackbarMsg = err
        })
    },
    loadTableData (index, name) {
      this.showtable = true
      const clickX = this.chartData.categories[index]
      this.clicktitle = 'nits' + name + '   ' + clickX
      const nits = parseInt(name)
      // 定義 YDIFF 區間
      const rangeStart = index * 0.02
      const rangeEnd = (index === 5) ? Infinity : rangeStart + 0.02
      console.info(rangeStart)
      console.info(rangeEnd)
      // 遍歷 responseAreaData，找出符合 nits 與 ydiff 區間的 brightnessList 項目
      const filteredData = []

      this.responseAreaData.forEach(item => {
        item.brightnessList.forEach(entry => {
          if (entry.nits === nits) {
            const ydiff = entry.ydiff
            if (
              (index === 5 && ydiff >= 0.1) || // others 區間
              (ydiff >= rangeStart && ydiff < rangeEnd)
            ) {
              filteredData.push({
                pk: item.pk,
                isn: item.deviceIsn,
                value: (ydiff * 100).toFixed(4) + '%'
              })
            }
          }
        })
      })

      this.newData = filteredData

      this.responseData = [...this.newData] // 触发 Vue 响应式更新
      this.pagination.current.totalItems = this.newData.length
      this.IsSubmitPage = true
      this.pages = Number(Math.ceil(this.newData.length / this.pagination.current.rowsPerPage))
      this.IsSubmitPage = false
      this.pagination.page = 1
    },
    selectchart (dataType) {
      if (dataType === 'result') {
        this.Mode = 'Result'
        this.doSubmit(dataType)
      } else if (dataType === 'srgb') {
        this.Mode = 'SRGB'
        this.doSubmit(dataType)
      } else {
        this.Mode = 'P3'
        this.doSubmit(dataType)
        // this.$http.post('/api/lcd/analyzeMgmt/calibrationMode', this.propData).then(res => res.data)
        //   .then(res => {
        //     if (res.status === 'success') {
        //       this.calibrationModeMenu = res.data
        //     }
        //   })
      }
    }
  }
}
</script>
<style>
/* .c3-axis-x .tick tspan:hover {
  cursor: pointer;
} */
.c3-chart-text {
  font-size: 12px !important; /* 調整數字字體大小 */
}
</style>
